import UserAvatar from "@/components/user-avatar";
import { boxclass, cn } from "@/helpers";
import type { Competency } from "@/types/competency";
import type { Scorecard } from "@/types/scorecard";

interface ScoreCardProps {
  competencies: Competency[];
  assessment: Scorecard;
}

export default function ScoreCard({ competencies, assessment }: ScoreCardProps) {
  function competencyAvg(competency_id: string) {
    const scores = assessment.scores[competency_id];
    if (!scores?.length) return 0;
    return scores.reduce((acc, curr) => acc + curr.score, 0) / scores.length;
  }
  return (
    <div className={cn(boxclass, "mb-8")}>
      {competencies.map((comp) => {
        const avg = competencyAvg(comp.id);
        const scoreclass = cn(
          "col-start-2 bg-midnight-blue p-2",
          avg !== 0 && "font-bold",
          avg === 0 && "col-span-2",
        );
        const comp_scores = assessment.scores[comp.id] ?? [];
        const comp_notes = assessment.notes[comp.id] ?? [];
        return (
          <div key={comp.id} className="mb-4 grid grid-cols-[20rem_2rem_1fr] gap-y-2">
            <div className="bg-midnight-blue p-2">
              <span className="font-bold">{comp.name}</span>
            </div>
            <div className={scoreclass}>{avg === 0 ? "Not assessed yet" : avg}</div>
            {avg !== 0 && <div className="bg-midnight-blue p-2" />}
            {comp_scores.map((user_score) => {
              const user_note = comp_notes.find((n) => n.user.id === user_score.user.id);
              return (
                <div
                  key={user_score.user.id}
                  className="col-span-3 grid grid-cols-[20rem_2rem_1fr]"
                >
                  <div className="col-start-1 flex gap-2 p-2 leading-3">
                    <UserAvatar user={user_score.user} />
                    <div>
                      {user_score.user.name}
                      <br />
                      <span className="text-sm text-slate-400">{user_score.user.email}</span>
                    </div>
                  </div>
                  <div className="col-start-2 p-2">{user_score.score}</div>
                  {user_note && (
                    <div className="col-span-1 col-start-3 p-2 text-sm">{user_note.note}</div>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
